import { navigate } from "@gatsbyjs/reach-router";
import { apiDirectCall } from "customHooks/useApi";
import { actionsTableListType } from "customHooks/useCompleoSimpleList";

const useActionsTable = (companyId: number, t: any) => {
    return (refreshListFunction: any) => {
        const result: actionsTableListType = [
            {
                icon: "check",
                tooltip: t("mergeApplicants"),
                onClick: async (event: any, rowData: any) => {
                    // const ids = (rowData.applicants || []).map(
                    //     (i: Compleo.IObject) => i.pk.split(":")[1]
                    // );
                    const type = rowData.type;
                    const value = rowData.value;
                    const dataResult = await apiDirectCall(
                        "/applicant/applicantmergegetbyduplicatedvalue",
                        "post",
                        {
                            companyId,
                            field: type,
                            value
                        }
                    );
                    const result: { pk: string }[] =
                        dataResult.data?.data?.applicants || [];
                    const ids = result.map(
                        (i: Compleo.IObject) => i.pk.split(":")[1]
                    );

                    const postAddress = `/applicant/merge/${ids.join(",")}`;
                    navigate(postAddress);
                }
            }
        ];

        return result;
    };
};

export default useActionsTable;
